import { render, staticRenderFns } from "./membership_manager.vue?vue&type=template&id=b2670810&"
import script from "./membership_manager.vue?vue&type=script&lang=js&"
export * from "./membership_manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports